import { connect } from 'react-redux';

import { VODCSSModules, VODBiEvents } from 'shared/utils/wix-connect';

import { getAllSettings } from 'shared/selectors/app-settings';
import { getCurrentSiteUser } from 'widget/selectors/current-site-user';

import { BaseAccountButton } from './account-button';

import styles from './account-button-strip.styl';


@connect(state => ({
  appSettings: getAllSettings(state),
  currentSiteUser: getCurrentSiteUser(state),
}))
@VODBiEvents()
@VODCSSModules(styles)
export default class AccountButtonStrip extends BaseAccountButton {
  static displayName = 'AccountButtonStrip';
}



// WEBPACK FOOTER //
// ./src/widget/components/account/account-button-strip.js